import React from 'react';
import { CollectionCategories } from '../../collection/components/CollectionCategories';
import { CardBody } from '../../components/CardBody';
import { CardFooter } from '../../components/CardFooter';
import { CardHeader } from '../../components/CardHeader';
import { CardTitle } from '../../components/CardTitle';
import { abTestState, environmentContextState, pageContextState, pageSubContextState } from '../../recoil/atoms';
import { WhyHoneylove } from '../../sections/WhyHoneylove';
import { DiscoverHoneylove } from '../../sections/DiscoverHoneylove';
import { NavCategoryContext } from '../../enums/NavCategoryContext.enum';
import { CollectionCards } from '../../collection/components/CollectionCards';
import { WorldsBestShapingPanel } from '../../components/WorldsBestShapingPanel';
import { HomePageFadeCarouselMobile } from '../../components/HomePageFadeCarouselMobile';
import { HoneyloveIRL } from '../../sections/HoneyloveIRL';
import { useLanderControls } from '../LanderContext';
import { Link } from '../../root/components/Link';
import { Button } from '../../root/components/buttons/Button';
import { PageContext } from '../../enums/PageContext.enum';
import { PageSubContext } from '../../enums/PageSubContext.enum';
import { isMobileState } from '../../recoil/selectors';
import { WorldsBestTitle } from '../../components/WorldsBestTitle';
import styles from './HomeLanderMobile.module.scss';
import HomePageSalePromo from '../../components/HomePageSalePromo';
import { useRecoilValue } from 'recoil';

export const HomeLanderMobile: React.FC = () => {
  const environmentContext = useRecoilValue(environmentContextState);
  return (
    <>
      <CardBody>
        <CollectionCategories context={NavCategoryContext.LandingPage} />
        {environmentContext.timedSaleActive ? <HomePageSalePromo /> : <HomePageFadeCarouselMobile />}
      </CardBody>
      <CardFooter inlineStyles={environmentContext.timedSaleActive ? { backgroundColor: '#e4beff' } : {}} />
      <CardHeader>
        <WorldsBestTitle />
      </CardHeader>
      <CardBody>
        <WorldsBestShapingPanel />
      </CardBody>
      <ShopNowCardFooter href="/products" />
      <CardHeader>
        <CardTitle text="Discover Honeylove" />
      </CardHeader>
      <CardBody>
        <DiscoverHoneylove />
      </CardBody>
      <ShopNowCardFooter href="/products" />
      <CardHeader>
        <CardTitle text="Featured" />
      </CardHeader>
      <CollectionCards hideHeader={true}></CollectionCards>
      <CardHeader>
        <CardTitle text="Why Honeylove" />
      </CardHeader>
      <CardBody>
        <WhyHoneylove hideSections={['size', 'return']} />
      </CardBody>
      <CardFooter />
      <CardHeader>
        <CardTitle>
          <div>
            <Link
              href="https://www.instagram.com/honeylove/?hl=en"
              target="_blank"
              dataTrackLabel="Honeylove Instagram"
              dataTrackLocation="homepage"
              buttonType="ghost"
              labelStyleOptions={{ color: '#6361e8' }}
              text="@honeylove"
            />{' '}
            IRL
          </div>
        </CardTitle>
      </CardHeader>
      <CardBody>
        <HoneyloveIRL />
      </CardBody>
      <ShopNowCardFooter href="/products" />
    </>
  );
};

export const ShopNowCardFooter = ({ label = 'Shop now', onClick, href }: { label?: string; onClick?: () => void; href?: string }): React.ReactElement => {
  const { scrollToProductSection } = useLanderControls();
  const pageContext = useRecoilValue(pageContextState);
  const pageSubContext = useRecoilValue(pageSubContextState);
  const abTests = useRecoilValue(abTestState);
  const isMobile = useRecoilValue(isMobileState);

  if (abTests['AB2022-02'] && isMobile && pageContext === PageContext.LandingPage && pageSubContext !== PageSubContext.Homepage) {
    return <></>;
  }

  if (href) {
    return (
      <CardFooter>
        <div className={styles.heroFooter}>
          <Link buttonType="secondary" size="medium" text={label} href={href} />
        </div>
      </CardFooter>
    );
  }

  return (
    <CardFooter>
      <div className={styles.heroFooter}>
        <Button size="medium" text={label} onClick={onClick ?? scrollToProductSection} />
      </div>
    </CardFooter>
  );
};

export const ShopNowCardSection = ({ label = 'Shop now', onClick }: { label?: string; onClick?: () => void }): React.ReactElement => {
  const { scrollToProductSection } = useLanderControls();
  const pageContext = useRecoilValue(pageContextState);
  const pageSubContext = useRecoilValue(pageSubContextState);
  const abTests = useRecoilValue(abTestState);
  const isMobile = useRecoilValue(isMobileState);

  if (abTests['AB2022-02'] && isMobile && pageContext === PageContext.LandingPage && pageSubContext !== PageSubContext.Homepage) {
    return <></>;
  }

  return (
    <div className={styles.heroFooter} style={{ boxSizing: 'border-box' }}>
      <Button size="medium" text={label} onClick={onClick ?? scrollToProductSection} />
    </div>
  );
};

export default HomeLanderMobile;
